// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  USER_LOGIN, USER_LOGOUT, FETCH_USER
} from '../actions/user'

const initialState = {
  appInitialized: false,
  token: null,
  user: null,
  user_data: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return {...state, token: action.payload.token, user: action.payload.user, user_data: action.payload.user_data}
    case USER_LOGOUT:
      return {...initialState}
    case FETCH_USER:
      return {
        ...state,
        user: action.payload,
      }
    default:
      return state
  }
}
